/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiCursorAWindowIcon20Solid = forwardRef('UiCursorAWindowIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2 5.25A3.25 3.25 0 0 1 5.25 2h8.5A3.25 3.25 0 0 1 17 5.25v5.546l-3.936-2.96c-1.877-1.41-4.56-.073-4.563 2.275L8.494 17H5.25A3.25 3.25 0 0 1 2 13.75v-8.5Z" }),
        React.createElement("path", { d: "M10.001 10.113c.002-1.112 1.272-1.746 2.162-1.077l6.526 4.906c1.305.981.61 3.06-1.024 3.058l-2.782-.003a.2.2 0 0 0-.16.08l-1.672 2.224c-.982 1.306-3.06.61-3.059-1.023l.01-8.165Z" })));
});
